module.exports = __webpack_public_path__ + "media/svg/ne-1b87356b.svg";